import { Option, TranslationFunction } from '@/types';

export const searchActions = ($t: TranslationFunction): Option[] => [
  {
    value: 'deliveryId',
    label: $t('kolliID')
  },
  {
    value: 'phoneNumber',
    label: $t('mobilePhone')
  },
  {
    value: 'ssn',
    label: $t('ssn')
  }
];

export const columns = ($t: TranslationFunction): Option[] => [
  {
    label: $t('mobilePhoneUpperCase'),
    value: 'phoneNumber'
  },
  {
    label: $t('kolliIDUpperCase'),
    value: 'deliveryIds'
  },
  {
    label: $t('lockerIdOrShelfUpperCase'),
    value: 'lockerIdOrShelf'
  },
  {
    label: $t('reservedUpperCase'),
    value: 'reservedTime'
  },
  {
    label: $t('reservationMadeByUpperCase'),
    value: 'reservedUserName'
  },
  {
    label: $t('deliveredUpperCase'),
    value: 'deliveryTime'
  },
  {
    label: $t('deliveredByUpperCase'),
    value: 'deliveryUserName'
  },
  {
    label: $t('assignedTimeByUpperCase'),
    value: 'assignedTime'
  },
  {
    label: $t('descriptionUpperCase'),
    value: 'descriptionText'
  }
];
